module.exports = __webpack_public_path__ + "static/img/banner.b04e60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SoftwareComparison/banner.png
// module id = Gzvm
// module chunks = 10